import axios from 'axios'
import { msalInstance, requestScopes } from './AuthConfig'
import { AUTH_PROVIDER } from '../App'
import { sdk } from './sdk'
import { parseJwt } from '../utils/jwt'

export const getBaseUrl = (): string => {
  switch (process.env.REACT_APP_STAGE) {
    case 'dev':
      return 'api-dev.sistemiv.com'
    case 'test':
      return 'api-test.sistemiv.com'
    case 'staging':
      return 'api-staging.sistemiv.com'
    default:
      return 'api.sistemiv.com'
  }
}

const fetchSession = async () => {
  const { data: session } = await sdk.toSession({
    tokenizeAs: 'sistemiv-dev',
  })
  localStorage.setItem('access_token', session.tokenized || '')
  return session.tokenized || ''
}

export const getSIdentityUrl = (): string => {
  if (AUTH_PROVIDER === 'msal') {
    return `https://identity${
      process.env.REACT_APP_STAGE !== 'prod' ? `-${process.env.REACT_APP_STAGE}` : ''
    }.sistemiv.com`
  }
  if (process.env.REACT_APP_S_IDENTITY_ORIGIN) {
    return process.env.REACT_APP_S_IDENTITY_ORIGIN
  }
  return 'https://account.sistemiv.com'
}

export const imageBase = `https://${getBaseUrl()}/iam/api/profile/picture`

const axiosInstance = axios.create({
  baseURL: `https://${getBaseUrl()}/iam/api`,
  headers: {
    'Content-Type': 'application/json',
  },
})

const authInterceptor = async (config: any) => {
  if (AUTH_PROVIDER === 'msal') {
    const instance = msalInstance
    const { accessToken } = await instance.acquireTokenSilent({
      scopes: requestScopes,
      account: msalInstance.getActiveAccount() ?? undefined,
    })
    if (config.headers) {
      config.headers.Authorization = `Bearer ${accessToken}`
    }
  } else {
    let token = localStorage.getItem('access_token')
    if (!token) {
      try {
        token = await fetchSession()
      } catch (error) {
        window.location.href = `${getSIdentityUrl()}/login?return_to=${window.location.origin}&env=${
          process.env.REACT_APP_STAGE
        }`
        return Promise.reject(error)
      }
    } else {
      const jwtExpiresAt = parseJwt(token)?.exp
      const expiresAt = new Date(jwtExpiresAt * 1000)
      const now = new Date()
      if (expiresAt < now) {
        try {
          token = await fetchSession()
        } catch (error) {
          window.location.href = `${getSIdentityUrl()}/login?return_to=${window.location.origin}&env=${
            process.env.REACT_APP_STAGE
          }`
          return Promise.reject(error)
        }
      }
    }
    if (config.headers) {
      config.headers.Authorization = `Bearer ${token}`
    }
  }
  return config
}

axiosInstance.interceptors.request.use(authInterceptor, (error: any) => Promise.reject(error))
axiosInstance.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response && [301, 302].includes(error.response.status)) {
      const redirectUrl = error.response.headers.location
      window.location.replace(redirectUrl)
    } else if (AUTH_PROVIDER === 'ory' && error.response && error.response.status === 401) {
      sdk
        .toSession({
          tokenizeAs: 'sistemiv-dev',
        })
        .then(({ data: session }) => {
          localStorage.setItem('access_token', session.tokenized || '')
        })
    } else {
      return Promise.reject(error)
    }
  },
)

export default axiosInstance
